// Tier copy, keyed by CourseType then CourseIntensity (see app/data/pricing.ts).
const en = {
  tierNames: {
    light: "Light",
    semiIntensive: "Semi-Intensive",
    intensive: "Intensive",
  },

  groupCourses: {
    light: {
      description: "A beginner-friendly course with a lighter schedule.",
      features: [
        "Live online classes once a week",
        "Q&A sessions after each class",
        "Access to recorded sessions",
        "Career guidance every 3 months",
        "Certificate of completion",
        "Community group access",
        "Monthly progress reports",
      ],
    },
    semiIntensive: {
      description:
        "More engagement with additional live classes and career content.",
      features: [
        "Live online classes twice a week",
        "Q&A sessions after each class",
        "Access to recorded sessions",
        "Monthly career guidance",
        "Job interview prep (bi-monthly)",
        "Group projects with feedback",
        "Study materials and resources",
      ],
    },
    intensive: {
      description:
        "The most immersive group course and personalized mentorship.",
      features: [
        "Live online classes four times a week",
        "Q&A sessions after each class",
        "Access to recorded sessions",
        "Bi-weekly career guidance",
        "Job interview prep (monthly)",
        "Group projects with mentorship",
        "Exclusive webinars and workshops",
      ],
    },
  },

  individualCourses: {
    light: {
      description:
        "A flexible course with personalized plans and moderate interaction.",
      features: [
        "Personalized learning plan",
        "Live online classes once a week",
        "Q&A after each class",
        "Access to recorded sessions",
        "Career guidance every 3 months",
        "One-on-one project feedback",
        "Study materials and resources",
      ],
    },
    semiIntensive: {
      description:
        "More frequent one-on-one interaction and expert mentorship.",
      features: [
        "Personalized learning plan",
        "Live online classes twice a week",
        "Q&A after each class",
        "Monthly career guidance",
        "Project mentorship and expert feedback",
        "Job interview prep (monthly)",
        "Priority study materials",
      ],
    },
    intensive: {
      description: "An all-in-one program with expert mentorship and support.",
      features: [
        "Personalized learning plan",
        "Live online classes four times a week",
        "Q&A after each class",
        "Bi-weekly career guidance",
        "In-depth project mentorship",
        "Job interview prep (bi-weekly)",
        "Priority email and chat support",
      ],
    },
  },
};

export default en;
